import React, { useEffect, useRef } from "react";
import { Room } from "./Room/Room";
import { useResourcesState } from "@/state/resourcesState";
import { Camera } from "three";

import { useFurnitureManagementState } from "@/state/furnitureManagementState";
import { FurnitureMouseInteractions } from "./FurnitureMouseInteractions";
import { CameraManagement } from "./Camera/CameraManagement";
import { useDemoState } from "@/state/demoState";
import { RoomScheme } from "@/3d/roomScheme/RoomScheme";
import { useThree } from "@react-three/fiber";
import { SETTINGS } from "@/utils/settings";
import { Environment } from "@react-three/drei";

export const RoomDemo: React.FC = () => {
    const isLoaded = useResourcesState((state) => state.isLoaded);
    const view = useDemoState((state) => state.view);

    const camera = useRef<Camera | null>(null);

    const instances = useFurnitureManagementState((state) => state.furnitureInstances);
    const three = useThree();

    useEffect(() => {
        if (SETTINGS.logDebugInfo) {
            const gl = three.gl.getContext();
            if (gl) {
                const renderer = gl.getParameter(gl.RENDERER);
                const supportedExtensions = gl.getSupportedExtensions();
                console.log("Debug info", { renderer, supportedExtensions });
            }
        }
    }, []);

    if (!isLoaded) {
        return null;
    }

    return (
        <group>
            {/* todo: each time we switch view, room and scheme geometry is re-created do we need to do something about it? */}
            {view === "3d" && <Room />}
            {view === "2d" && <RoomScheme cameraRef={camera} />}
            <CameraManagement
                cameraRef={camera}
                camera={view === "3d" ? "perspective" : "orthographic"}
            />
            <FurnitureMouseInteractions cameraRef={camera} furnitureInstances={instances} />
            <Environment
                environmentIntensity={0.1}
                resolution={2048}
                files={["assets/materials/lebombo_2k.hdr"]}
            />
        </group>
    );
};
